import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { MYREVENUESALESCHART_INIT_LOADING, MYREVENUESALESCHART_INIT_SUCCESS, MYREVENUESALESCHART_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'

const state = {
  myRevenueSalesChart: {
    init: 0,
    menu: {},
    lastUpdated: null,
    scope: null,
    appId: null,
    info: null,
    appIds: [],
    chartInfo: []
  }
}

const getters = {
}

const actions = {
  async initMyRevenueSalesChart({ commit, state }, data) {
    commit(MYREVENUESALESCHART_INIT_LOADING)
    const apiUrl = state.permitWidgets.myRevenueSalesChart
    if (apiUrl) {
      try {
        let params = {
          scope: data.scope,
          appId: data.appId
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)

        Object.assign(data, {
          menu: menu,
          info: result.data.info,
          appIds: result.data.appIds,
          chartInfo: result.data.chartInfo
        })
        commit(MYREVENUESALESCHART_INIT_SUCCESS, data)
      } catch (error) {
        commit(MYREVENUESALESCHART_INIT_FAIL)
      }
    } else {
      commit(MYREVENUESALESCHART_INIT_FAIL)
    }
  }
}

const mutations = {
  [MYREVENUESALESCHART_INIT_LOADING](state) {
    state.myRevenueSalesChart.init = 0
  },
  [MYREVENUESALESCHART_INIT_SUCCESS](state, data) {
    const { myRevenueSalesChart } = state
    myRevenueSalesChart.menu = data.menu
    myRevenueSalesChart.init = 1
    myRevenueSalesChart.lastUpdated = new Date()
    myRevenueSalesChart.scope = data.scope
    myRevenueSalesChart.appId = data.appId
    myRevenueSalesChart.info = data.info
    myRevenueSalesChart.appIds = data.appIds
    Vue.set(myRevenueSalesChart, 'chartInfo', data.chartInfo)
  },
  [MYREVENUESALESCHART_INIT_FAIL](state) {
    state.myRevenueSalesChart.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
